import { useCallback, useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router';
import { app } from '@microsoft/teams-js';
import BroadcastMessageForm from './BroadcastMessageForm';
import BroadcastMessageReportPanel from '../ReportingPage/Panels/BroadcastMessagePanel/BroadcastMessageReportPanel';
import { BroadcastMessageWithStatistic } from '../../model';

type View = 'messageList' | 'form';

const BroadcastMessagingDialogPage = () => {
    const { dataKey } = useParams();
    const [searchParams] = useSearchParams();

    const append = searchParams.get('append')?.toLowerCase() === 'true';

    const [view, setView] = useState<View>(append ? 'messageList' : 'form');
    const [flightTeamIds, setFlightTeamIds] = useState<string[]>([]);
    const [broadcastMsg, setBroadcastMsg] = useState<
        BroadcastMessageWithStatistic | undefined
    >();

    useEffect(() => {
        if (dataKey) {
            const appData = localStorage.getItem(dataKey);

            if (appData) {
                setFlightTeamIds(appData.split(','));
            }
        }

        return () => {
            if (dataKey) {
                localStorage.removeItem(dataKey);
            }
        };
    }, [dataKey, append]);

    useEffect(() => {
        app.notifySuccess();
    }, [dataKey]);

    const onListRowClickCallback = useCallback(
        (msg: BroadcastMessageWithStatistic) => {
            setBroadcastMsg(msg);
            setView('form');
        },
        []
    );

    return view === 'form' ? (
        <BroadcastMessageForm
            flightTeamIds={flightTeamIds}
            broadcastMessage={broadcastMsg}
        />
    ) : (
        <BroadcastMessageReportPanel
            mode="simple"
            onRowClick={onListRowClickCallback}
        />
    );
};

export default BroadcastMessagingDialogPage;
